import React, { useCallback } from "react";
import { Form, Input } from "antd";

const BookManagerHeader = ({ addresses, setAddresses }) => {
  const filterAddresses = useCallback(
    value => {
      const markedSearchAddresses = addresses.map(addr => {
        const { name, addressLine1 } = addr;

        let valueLower = value.toLowerCase();
        const containsLocationName = name.toLowerCase().indexOf(valueLower) !== -1;
        const containsAddressLine1 = addressLine1.toLowerCase().indexOf(valueLower) !== -1;

        addr.hide = !containsLocationName && !containsAddressLine1;

        return addr;
      });

      setAddresses(markedSearchAddresses);
    },
    [addresses, setAddresses],
  );

  return (
    <div>
      Address Book
      <div>
        <Form.Item label="Search" style={{ marginTop: 10, marginBottom: 0 }}>
          <Input onChange={event => filterAddresses(event.target.value)} placeholder="Enter Location Name or Address" />
        </Form.Item>
      </div>
    </div>
  );
};

export default BookManagerHeader;
